import React from 'react';
import {Row, Col} from "react-flexbox-grid";
import "react-datepicker/dist/react-datepicker.css";

const EnergizationStatus = ({ preEForm}) =>
    <Row controlId='energizationStatus' style={{alignItems: 'left', marginTop: 8, marginBottom: 8}}>
        <label className='col-xs-12 col-sm-2' style={{ margin: 0}}>Energization Status:</label>
        <label className='col-xs-12 col-sm-4' style={{ margin: 0, textAlign: 'left'}}>{preEForm.energizationStatusDesc}</label>
    </Row>

export default EnergizationStatus;
